<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';

  // Import Main styles for this application
  @import 'assets/scss/style';
  @import "node_modules/font-awesome/scss/font-awesome.scss";
</style>
